document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.feature-hero .feature-hero__buttons .hv2-button');
    var buttonsContainer = document.querySelector('.feature-hero .feature-hero__buttons.hasButtonMobile');
  
    if (buttonsContainer) {
        var originalAttributes = [];

        buttons.forEach(function (button) {
            var originalAttribute = {
                name: button.childNodes[0].nodeValue,
                link: button.href,
                target: button.target
            };
            originalAttributes.push(originalAttribute);
        });

        function replaceAttributes() {
            var windowWidth = $(window).width();

            if (windowWidth <= 991) {
                buttons.forEach(function (button, index) {
                    button.childNodes[0].nodeValue = button.getAttribute('data-button-name');
                    button.href = button.getAttribute('data-button-link');
                    button.target = button.getAttribute('data-button-target');
                });
            } else {
                buttons.forEach(function (button, index) {
                    button.childNodes[0].nodeValue = originalAttributes[index].name;
                    button.href = originalAttributes[index].link;
                    button.target = originalAttributes[index].target;
                });
            }
        }

        replaceAttributes();

        window.addEventListener('resize', replaceAttributes);
    }
});
